export default class WebUtil {
  static isMobileScreen() {
    return (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < 700
    );
  }
}
